var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMulticolorChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.979 23.0742H67.604C68.2756 23.0742 68.923 23.3077 69.438 23.7295L69.6509 23.9219C70.1937 24.4647 70.4985 25.2011 70.4985 25.9688V54.4688C70.4985 55.2364 70.1937 55.9728 69.6509 56.5156C69.108 57.0585 68.3717 57.3633 67.604 57.3633H63.3735V67.1055L53.8267 57.5586L53.6304 57.3633H31.979C31.3075 57.3633 30.66 57.1298 30.145 56.708L29.9321 56.5156C29.3893 55.9728 29.0845 55.2364 29.0845 54.4688V25.9688C29.0845 25.2972 29.3179 24.6498 29.7397 24.1348L29.9321 23.9219C30.475 23.379 31.2113 23.0742 31.979 23.0742Z",
    fill: "#E3EDC3",
    stroke: "#274642",
    strokeWidth: 1.33594
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.729 15.9492H53.354C54.0256 15.9492 54.673 16.1827 55.188 16.6045L55.4009 16.7969C55.9437 17.3397 56.2485 18.0761 56.2485 18.8438V47.3438C56.2485 48.1114 55.9437 48.8478 55.4009 49.3906C54.858 49.9335 54.1217 50.2383 53.354 50.2383H31.7026L31.5063 50.4336L21.9595 59.9805V50.2383H17.729C17.0575 50.2383 16.41 50.0048 15.895 49.583L15.6821 49.3906C15.1393 48.8478 14.8345 48.1114 14.8345 47.3438V18.8438C14.8345 18.1722 15.0679 17.5248 15.4897 17.0098L15.6821 16.7969C16.1571 16.3219 16.7803 16.0297 17.4429 15.9639L17.729 15.9492Z",
    fill: "white",
    stroke: "#274642",
    strokeWidth: 1.33594
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.854 36.6562C26.8215 36.6562 28.4165 35.0613 28.4165 33.0938C28.4165 31.1262 26.8215 29.5312 24.854 29.5312C22.8865 29.5312 21.2915 31.1262 21.2915 33.0938C21.2915 35.0613 22.8865 36.6562 24.854 36.6562Z",
    fill: "#274642"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5415 36.6562C37.509 36.6562 39.104 35.0613 39.104 33.0938C39.104 31.1262 37.509 29.5312 35.5415 29.5312C33.574 29.5312 31.979 31.1262 31.979 33.0938C31.979 35.0613 33.574 36.6562 35.5415 36.6562Z",
    fill: "#274642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.229 36.6562C48.1965 36.6562 49.7915 35.0613 49.7915 33.0938C49.7915 31.1262 48.1965 29.5312 46.229 29.5312C44.2615 29.5312 42.6665 31.1262 42.6665 33.0938C42.6665 35.0613 44.2615 36.6562 46.229 36.6562Z",
    fill: "#274642"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulticolorChatIcon);
export default __webpack_public_path__ + "static/media/MulticolorChatIcon.c424de8d8bd16e7a6c597470a837201e.svg";
export { ForwardRef as ReactComponent };